declare var angular: ng.IAngularStatic;
export class compareService {
    compareUrl
    constructor(private localStorageService, private $notify, public $rootScope, private $mPath, private $window) {
        "ngInject"

        this.$mPath.get().then(
            response => {
                this.compareUrl = response.StoreCompare + "/"
            }
        )
    }

    get(productTypeID) {
        let obj = this.localStorageService.get(`compare${productTypeID}`) || []
        return obj;
    }

    add(productTypeID, product) {
        let obj = this.get(productTypeID);

        let isExist = this.checkExist(obj, product)
        if (obj.length > 4) {
            let actionUrl = this.doComareUrl(productTypeID)
            this.$notify.action({ text: 'تعداد محصول های لیست مقایسه نمی تواند بیشتر از 5 عدد باشد', action: "برو به صفحه مقایسه", actionUrl: actionUrl })
        }
        if (isExist) {
            let actionUrl = this.doComareUrl(productTypeID)
            this.$notify.action({ text: 'این محصول در لیست مقایسه وجود دارد', action: "برو به صفحه مقایسه", actionUrl: actionUrl })
            product.compareStatus = true;
        }
        if (!isExist && obj.length < 5) {
            obj.push(product)
            this.localStorageService.set(`compare${productTypeID}`, obj)
            let actionUrl = this.doComareUrl(productTypeID)

            this.$notify.action({ text: 'این محصول با موفقیت به لیست مقایسه اضافه شد', action: "برو به صفحه مقایسه", actionUrl: actionUrl })
            this.$rootScope.$emit('addCompare')
            product.compareStatus = true;
        }
    }

    remove(productTypeID, product) {
        let obj = this.get(productTypeID);
        obj = this.removeItem(obj, product)
        this.localStorageService.set(`compare${productTypeID}`, obj)
        this.$notify.show({ text: 'با موفقیت از لیست حذف شد' })
    }

    clear(productTypeID) {
        let obj = [];
        this.localStorageService.set(`compare${productTypeID}`, obj)
        this.$notify.show({ text: 'لیست با موفقیت پاک سازی شد' })
    }

    doComareUrl(productTypeID) {
        let urlAddon = ""
        let items = this.get(productTypeID)
        angular.forEach(items, (val) => {
            urlAddon = urlAddon + val.ProductID + '/';
        })
        return this.compareUrl + urlAddon;
    }

    doCompare(productTypeID){
        let compareUrl = this.doComareUrl(productTypeID)
        this.$window.location.href = compareUrl;
    }

    private checkExist(obj, product) {
        let isExist = false;
        angular.forEach(obj, (val) => {
            if (val.ProductID === product.ProductID) {
                isExist = true;
            }
        })
        return isExist
    }

    private removeItem(obj, product) {
        angular.forEach(obj, (val, key) => {
            if (val.ProductID === product.ProductID) {
                obj.splice(key, 1)
            }
        })
        return obj
    }

}


// WEBPACK FOOTER //
// ./src/services/compare/compare.ts